// The backend appends a machine-readable reference tag — `[Ref: QMS-Q-2026-0001]` —
// to every outbound inquiry subject so supplier replies can be threaded back to the
// inquiry even when a mail client drops the In-Reply-To/References headers. It's owned
// by the backend (never editable in a template) and only appears on SENT subjects.
//
// For display we split it back out so the UI shows a clean subject plus a discrete
// reference chip, instead of the raw `[Ref: ...]` text inline. Mirrors the backend's
// turnus_ai/services/email_reference_token.py regex.
const REFERENCE_TOKEN_RE = /\s*\[Ref:\s*([^\]]+?)\s*\]/i

export interface SubjectWithReference {
  /** Subject with the reference tag removed (trimmed). */
  subject: string
  /** The reference value if the subject carried a tag, else null. */
  reference: string | null
}

export function splitReferenceToken(
  subject: string | null | undefined,
): SubjectWithReference {
  if (!subject) return { subject: subject ?? "", reference: null }
  const match = subject.match(REFERENCE_TOKEN_RE)
  if (!match) return { subject, reference: null }
  return {
    subject: subject.replace(REFERENCE_TOKEN_RE, "").trim(),
    reference: match[1].trim(),
  }
}
